import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import "./Aurora.css"; // Import CSS med nordlys-animasjon

// Bakgrunnsbilde
import bgImage from "assets/images/backgrounds/sign-in-image.webp";

function Basic() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://polaris.polarcode.solutions/auth/login", {
        username,
        password,
      });
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      console.error("Innlogging feilet", error);
    }
  };

  const handlePasswordReset = () => {
    navigate("/reset-password"); // Navigerer til tilbakestillingssiden
  };

  return (
    <MDBox
      sx={{
        position: "relative",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      <div className="aurora-overlay"></div> {/* Nordlys-animasjon */}

      <Card
        sx={{
          backdropFilter: "blur(10px)",
          background: "rgba(0, 0, 0, 0.6)", // Mørkere for bedre kontrast
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.8)",
          borderRadius: "15px",
          padding: "2rem",
          width: "350px",
          zIndex: 2, // Over animasjonen
          color: "white", // Hvit tekst for god kontrast
        }}
      >
        <MDTypography variant="h4" fontWeight="bold" color="white" textAlign="center" mb={2}>
          PolarCode Solutions
        </MDTypography>
        <MDTypography variant="h6" fontWeight="bold" color="white" textAlign="center" mb={2}>
          Admin Portal
        </MDTypography>
        <MDBox component="form" role="form" onSubmit={handleLogin} mt={3}>
          <MDInput
            type="text"
            label="Username"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            InputLabelProps={{
              style: { color: "rgba(255, 255, 255, 0.7)" }, // Lysere label-farge
            }}
            inputProps={{
              style: { color: "white" }, // Gjør input-teksten hvit
            }}
            sx={{
              background: "rgba(255, 255, 255, 0.15)",
              borderRadius: "10px",
              mb: 2,
              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px rgba(255, 255, 255, 0.15) inset",
                WebkitTextFillColor: "white",
              },
            }}
          />
          <MDInput
            type="password"
            label="Password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputLabelProps={{
              style: { color: "rgba(255, 255, 255, 0.7)" }, // Lysere label-farge
            }}
            inputProps={{
              style: { color: "white" }, // Gjør input-teksten hvit
            }}
            sx={{
              background: "rgba(255, 255, 255, 0.15)",
              borderRadius: "10px",
              mb: 2,
              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px rgba(255, 255, 255, 0.15) inset",
                WebkitTextFillColor: "white",
              },
            }}
          />

          {error && (
            <MDTypography color="error" variant="button" mt={2}>
              {error}
            </MDTypography>
          )}

          <MDBox mt={4}>
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              type="submit"
              sx={{
                background: "linear-gradient(90deg, #00c6ff, #0072ff)",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Sign In
            </MDButton>
          </MDBox>

          {/* Tilbakestill passord knapp */}
          <MDBox mt={2} textAlign="center">
            <MDButton
              variant="text"
              color="info"
              onClick={handlePasswordReset}
              sx={{
                textTransform: "none",
                fontWeight: "medium",
                color: "rgba(255, 255, 255, 0.8)",
                "&:hover": {
                  color: "white",
                  textDecoration: "underline",
                },
              }}
            >
              Forgot your password?
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
}

export default Basic;
